// @import dependencies
import React, {Component} from 'react'
import { connect } from 'react-redux'
import { CombinedReducers as IState } from 'app_events/index'
// @end

// @import components
import {PostScreenLayout} from 'app_components/screens/admin/post'
// @end

// @import events
// @end

// @import utils
import { ScreenNotificationsUtil } from 'app_utils/screenNotification'
import { I18nUtil } from 'app_utils/i18n'
// @end

// @import services
import PermissionService from 'app_services/secure/permission/permissionService'
import PostService from 'app_services/admin/post/postService'
// @end

// @import types
import { IPagination } from 'app_types/pagination/paginationTypes'
import { INewPost, IPostListItem, IPostsHttpResponse } from 'app_types/admin/post/postTypes'
// @end

// @ADD Component types
interface IPostScreenProps {}
interface IPostScreenState {
  status: null | 'loading' | 'error'
  itemList: IPostListItem[]
  add: boolean
  edit: boolean
  view: boolean
  editData: null | IPostListItem
  selectedRow: null | string
  pagination: IPagination
}

// @INFO: Connect react storage state
const mapStatesToProps = (state: IState) => {return state}

class PostScreen extends Component<IPostScreenProps, IPostScreenState> {

  public moduleName: string = 'module:posts'
  private permission: PermissionService
  private screenNotifications: ScreenNotificationsUtil
  private itemService: PostService
  private i18nUtil: I18nUtil

  /*===============================================
  =            Estructura de un metodo            =
  ================================================
    // La estructura de un metodo debe ser la siguiente:
    methodName = () => {}
  /*======  End of Estructura de un metodo  =====*/

  constructor(props: IPostScreenProps) {
    super(props)
    this.state = {
      status: 'loading',
      itemList: [],
      add: false,
      edit: false,
      view: false,
      editData: null,
      selectedRow: null,
      pagination: {
        page: 1,
        perPage: 10,
        total: 0,
      },
    }

    this.permission = new PermissionService(this.moduleName)
    this.screenNotifications = new ScreenNotificationsUtil()
    this.itemService = new PostService()
    this.i18nUtil = new I18nUtil()
  }

  /**
   * Evento que se ejecuta cuando el componente es montado
   */
  componentDidMount = async () => {
    await this.getList()
  }

  /**
   * Evento que se ejecuta cuando el componente es desmontado
   */
  componentWillUnmount = () => {}

  /**
   * Evento que se ejecuta cuando el componente es actualizado
   */
  componentDidUpdate = () => {}

  // @Add custom methods

  onRowClick = async (row: any) => {
    if (this.state.selectedRow === row._id) {
      this.setState({ selectedRow: null })
    } else {
      // this.setState({ status: 'loading' })
      const item: any = this.state.itemList.find((item) => item._id === row._id)

      if (!item?.details) {
        await this.getItem(row._id)
      }

      this.setState({
        selectedRow: row._id,
        // status: null,
      })
    }
  }

  showAddForm = async (add: boolean) => {
    this.setState({ add })
  }

  showEditForm = async (edit: boolean, register?: any) => {
    if (edit && register) {
      await this.getItem(register._id)
      this.setState({ edit: true, editData: register })
    } else {
      this.setState({ edit: false })
    }
  }

  onViewerRow = async (view: boolean, register?: any) => {
    if (view && register) {
      await this.getItem(register._id)
      this.setState({ view: true, editData: register })
    } else {
      this.setState({ view: false })
    }
  }

  onPageChange = async (page: number) => {
    this.getList({ page })
  }

  onSearch = async (event: any) => {
    this.getList({ page: 1, search: event.search })
    return false
  }

  getItem = async (id: string) => {
    // this.setState({ status: 'loading' })

    const itemIndex = this.state.itemList.findIndex((item) => item._id === id)
    const itemList: Array<any> = [...this.state.itemList]

    const item: any = await this.itemService.getOne(id)
    if (item) {
      itemList[itemIndex].details = item
    } else {
      // this.setState({ status: 'error' })
    }
  }

  getList = async (params?: any) => {
    this.setState({ status: 'loading' })

    const httpParams: any = {
      pageNumber: params?.page ? params?.page : this.state.pagination.page,
      nPerPage: params?.perPage ? params?.perPage : this.state.pagination.perPage,
      // isActive: false
    }

    if (params?.search) {
      httpParams.search = params?.search
    }

    let itemList: IPostsHttpResponse | null = await this.itemService.list(httpParams)

    if (itemList?.status_code === 'success') {
      this.setState({
        itemList: itemList?.posts,
        pagination: {
          total: itemList?.total_register,
          perPage: itemList?.nPerPage,
          page: itemList?.pageNumber,
        },
        status: null,
      })
    } else {
      this.setState({ status: 'error' })
    }
  }

  addItem = async (response: any) => {
    if (response) {
      this.setState({ add: false })
      this.getList()
    }
  }

  updateItem = async (response: INewPost) => {
    if (response) {
      this.setState({ edit: false })
      this.getList()
    }
  }

  removeItem = async (id: string) => {
    let confirm = this.screenNotifications.fire({
      message: `${this.i18nUtil.getTranslate('screens.posts.delete.message')}`,
    },
    {
      type: 'warning',
      title: `${this.i18nUtil.getTranslate('screens.posts.delete.title')}`,
      confirmButtonText: `${this.i18nUtil.getTranslate('components.screen_notifications.buttons.confirmButtonText')}`,
      cancelButtonText: `${this.i18nUtil.getTranslate('components.screen_notifications.buttons.cancelButtonText')}`,
      showCancelButton: true,
    })

    if (confirm) {
      confirm.then(async (result) => {
        if (result.value) {
          // this.setState({ status: 'loading' })

          const remove = await this.itemService.remove(id)

          if (remove) {
            this.screenNotifications.fireToast(
              {
                message: `${this.i18nUtil.getTranslate('components.screen_notifications.delete')}`,
              },
              {
                position: 'bottom-right',
              },
            )

            this.getList()
          }

          // this.setState({ status: null })
        }
      })
    }
  }

  render() {
    return(
      <PostScreenLayout
        add={this.permission.check('permission:posts_create', this.state.add)}
        edit={this.permission.check('permission:posts_update', this.state.edit)}
        view={this.permission.check('permission:posts_viewer', this.state.view)}
        editData={this.state.editData}
        onRowClick={this.onRowClick}
        onViewerRow={this.permission.check('permission:posts_viewer', this.onViewerRow)}
        selectedRow={this.state.selectedRow}
        showAddForm={this.permission.check('permission:posts_create', this.showAddForm)}
        showEditForm={this.permission.check('permission:posts_update', this.showEditForm)}
        pagination={this.state.pagination}
        onPageChange={this.onPageChange}
        itemList={this.permission.check('permission:posts_list', this.state.itemList)}
        addItem={this.permission.check('permission:posts_create', this.addItem)}
        updateItem={this.permission.check('permission:posts_update', this.updateItem)}
        removeItem={this.permission.check('permission:posts_delete', this.removeItem)}
        onSearch={this.permission.check('permission:posts_list', this.onSearch)}
        status={this.state.status}
      />
    )
  }
}

export default connect(mapStatesToProps)(PostScreen)
